"use client"

import { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react"
import { DataGrid } from "@mui/x-data-grid"
import {
  IconButton,
  ThemeProvider,
  createTheme,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Button,
  Box,
  Typography,
  Chip,
  InputAdornment,
  alpha,
  Tooltip,
  FormControl,
  InputLabel,
  Fade,
  Alert,
  Drawer,
  Divider,
  Badge,
  Paper,
} from "@mui/material"
import VisibilityIcon from "@mui/icons-material/Visibility"
import SearchIcon from "@mui/icons-material/Search"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff"
import WarehouseIcon from "@mui/icons-material/Warehouse"
import PersonIcon from "@mui/icons-material/Person"
import PriceChangeIcon from "@mui/icons-material/PriceChange"
import PercentIcon from "@mui/icons-material/Percent"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import ClearIcon from "@mui/icons-material/Clear"
import EditIcon from "@mui/icons-material/Edit"
import SaveIcon from "@mui/icons-material/Save"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
// </CHANGE>
import CustomPagination from "../transaccionComponent/CustomPagination" // Tu componente de paginación
import ModalActualizarPrecioEntidades from "./ModalActualizarPrecioEntidades" // Importar el modal mejorado
import ModalEditarPrecioId from "./ModalEditarPrecioId" // Tu componente de paginación
import { ErpContext } from "../../context/ErpContext.js"
import ModalAsociarItemPorCliente from "./ModalAsociarItemPorCliente"
import TuneIcon from "@mui/icons-material/Tune"
import CloseIcon from "@mui/icons-material/Close"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import MoneyOffIcon from "@mui/icons-material/MoneyOff"
import SwapHorizIcon from "@mui/icons-material/SwapHoriz"

// Tema personalizado con colores corporativos
const theme = createTheme({
  palette: {
    primary: {
      main: "#5b5b5f",
      light: "#4791db",
      dark: "#115293",
    },
    secondary: {
      main: "#4caf50", // Verde para precios
    },
    background: {
      default: "#f5f7fa",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
})

export default function TablaListaPrecio() {
  const {
    getListaMontosByEntidad,
    getEntidadFilterTipoEntidad,
    getItemTresLetras,
    itemTresLetras,
    arrayItemTresLetras,
    getTop10ItemVentas,
    getItemAtributoNoEliminados,
    itemAtributoNoEliminados,
    getUbicacion,
    ubicaciones,
    updateAllPrices,
    updateFilteredPrices,
    updateItemPrecioListaId,
    updatePreciosListaMultiple,
    copiarPreciosEntreEntidades,
    isNavbarCollapsed,
  } = useContext(ErpContext)

  // Estados
  const [proveedores, setProveedores] = useState([])
  const [itemsProveedor, setItemsProveedor] = useState([])
  const [selectedProveedor, setSelectedProveedor] = useState(null)
  const [searchText, setSearchText] = useState("") // Texto de búsqueda
  const [topVentasItems, set10VentasItems] = useState(null)
  const [filteredItems, setFilteredItems] = useState([])
  const [selectedItem, setSelectedItem] = useState(null) // Almacena el ítem seleccionado, el id y sus datos
  const [attributeValues, setAttributeValues] = useState([]) // Almacena los valores de los atributos activos
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100) // Cantidad de filas por página

  const [totalPages, setTotalPages] = useState(0) // Total de páginas
  const [totalCount, setTotalCount] = useState(0) // Total de registros
  const [isLoading, setIsLoading] = useState(false)
  const [valorActualizar, setValorActualizar] = useState("")
  const [tipoAjuste, setTipoAjuste] = useState("porcentaje") // "porcentaje" o "valor"
  const [openModal, setOpenModal] = useState(false)
  const [precioLista, setPrecioLista] = useState(0)
  const [updateSuccess, setUpdateSuccess] = useState(false)
  const [soloUltimos, setSoloUltimos] = useState(true) // Marcado por defecto
  const [incluirItemsSinPrecio, setIncluirItemsSinPrecio] = useState(false) // Mantener funcionalidad de main
  const [openAsociar, setOpenAsociar] = useState(false)

  const [openModalActualizar, setOpenModalActualizar] = useState(false)
  const [entidades, setEntidades] = useState([])
  const [entidadesCargadas, setEntidadesCargadas] = useState(false)

  // Edición inline de precios - FUNCIONALIDAD NUEVA DE BRANCH_MAURI
  const [editMode, setEditMode] = useState(false)
  const [editedPrices, setEditedPrices] = useState({}) // { [rowId]: string }
  const [savingEdits, setSavingEdits] = useState(false)
  const [modifiedCount, setModifiedCount] = useState(0)
  // const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // FUNCIONALIDAD NUEVA DE BRANCH_MAURI - Reemplazado por Collapse en Drawer

  // === ESTADOS PARA FILTROS DINÁMICOS POR ATRIBUTOS ===
  const [filtrosAtributos, setFiltrosAtributos] = useState({}) // { itemDatoAtributo1: "Samsung", ... }
  // const [masFiltrosActive, setMasFiltrosActive] = useState(false); // Mostrar/ocultar filtros avanzados - Reemplazado por Collapse en Drawer
  
  // Debouncing para searchText
  const [debouncedSearchText, setDebouncedSearchText] = useState("")

  // Navegación/edición tipo planilla - FUNCIONALIDAD NUEVA DE BRANCH_MAURI
  const [editingRowId, setEditingRowId] = useState(null)
  const [selectAllOnEdit, setSelectAllOnEdit] = useState(true)
  const [editModeInternal, setEditModeInternal] = useState(false) // Para distinguir entre edición completa e interna
  const [isNavigating, setIsNavigating] = useState(false) // Para distinguir entre navegación programática y edición manual
  const [shouldFocusOnEnter, setShouldFocusOnEnter] = useState(false) // Solo enfocar cuando se presiona Enter
  const priceInputRefs = useRef({})

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [mostrarFiltroAtributos, setMostrarFiltroAtributos] = useState(false)
  const [mostrarActualizacionPrecios, setMostrarActualizacionPrecios] = useState(false)

  // Debouncing para searchText
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText)
    }, 300)
    return () => clearTimeout(timer)
  }, [searchText])

  // Efecto para buscar items cuando el texto de búsqueda cambia (con debouncing)
  useEffect(() => {
    if (debouncedSearchText.length >= 3) {
      arrayItemTresLetras([])
      getItemTresLetras(debouncedSearchText) // Llama a la API
    } else {
      arrayItemTresLetras([])
      arrayItemTresLetras(topVentasItems)
      setFilteredItems([]) // Vacía las opciones si hay menos de 3 letras
    }
  }, [debouncedSearchText])

  // Efecto para cargar datos iniciales (sin cargar todas las entidades)
  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true)
      try {
        await getItemAtributoNoEliminados()
        await getUbicacion()
        const top10items = await getTop10ItemVentas()
        if (top10items) {
          // Mapeo para extraer los datos internos del item
          const mappedTop10 = top10items.map(({ item, ventas }) => ({
            id: item.id,
            codigo: item.codigo,
            descripcion: item.descripcion,
            codigoScanner: item.codigoScanner,
          }))
          set10VentasItems(mappedTop10)
          arrayItemTresLetras(mappedTop10)
        }
        // Solo cargar proveedores básicos, no todas las entidades
        const entidadesProveedores = await getEntidadFilterTipoEntidad(1) // ID tipo cliente
        setProveedores(entidadesProveedores)
        // No cargar entidades aquí - se cargarán bajo demanda
      } catch (error) {
        console.error("Error al obtener datos iniciales:", error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchInitialData()
  }, [])

  // Efecto para cargar items iniciales - MANTENER LÓGICA DE MAIN
  useEffect(() => {
    fetchItems(null, null, null, true, 1, limit, null, false, {}) // Usar soloUltimos = true por defecto, incluirItemsSinPrecio = false, sin filtros de atributos
  }, [])

  // OPTIMIZACIÓN: Función para cargar entidades bajo demanda
  const cargarEntidadesSiNoExisten = useCallback(async () => {
    if (!entidadesCargadas) {
      try {
        const entidadesProveedores = await getEntidadFilterTipoEntidad(1) // ID tipo cliente
        setEntidades(entidadesProveedores)
        setEntidadesCargadas(true)
      } catch (error) {
        console.error("Error al cargar entidades:", error)
      }
    }
  }, [entidadesCargadas, getEntidadFilterTipoEntidad])

  // OPTIMIZACIÓN: Memoizar si hay filtros activos (excepto soloUltimos que es el default)
  const hayFiltrosActivos = useMemo(() => {
    return !!(
      selectedProveedor ||
      selectedItem ||
      selectedUbicacion ||
      (searchText && searchText.trim() !== "") ||
      Object.values(filtrosAtributos).some((valor) => valor && valor.trim() !== "")
    )
  }, [selectedProveedor, selectedItem, selectedUbicacion, searchText, filtrosAtributos])

  // OPTIMIZACIÓN: Memoizar entidades únicas de los productos filtrados en la tabla
  const entidadesFiltradas = useMemo(() => {
    // Si NO hay filtros activos, mostrar todas las entidades disponibles
    if (!hayFiltrosActivos) {
      return entidades.length > 0 ? entidades : proveedores
    }

    // Si hay filtros pero no hay productos en la tabla, usar todas las entidades disponibles
    if (!itemsProveedor || itemsProveedor.length === 0) {
      return entidades.length > 0 ? entidades : proveedores
    }

    // Extraer IDs únicos de entidades de los productos mostrados (cuando hay filtros activos)
    const idsUnicos = [...new Set(itemsProveedor.map((item) => item.idEntidad).filter((id) => id != null))]

    // Filtrar las entidades para mostrar solo las que tienen productos en la tabla
    const entidadesFiltradas = entidades.filter((entidad) => idsUnicos.includes(entidad.id))

    // Si no hay entidades filtradas, usar todas las entidades disponibles
    return entidadesFiltradas.length > 0 ? entidadesFiltradas : (entidades.length > 0 ? entidades : proveedores)
  }, [hayFiltrosActivos, itemsProveedor, entidades, proveedores])

  // Función para generar etiqueta de item
  const generateItemLabel = (item) => {
    // Filtrar los atributos no eliminados
    const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)

    // Crear el label concatenando los atributos activos
    const attributeValues = activeAttributes
      .map((attr, index) => {
        // Verificar si el valor del atributo es null o undefined, y asignar un valor predeterminado en ese caso
        const attributeValue = item[`itemDatoAtributo${index + 1}`]
        return attributeValue ? attributeValue : "" // Si es null o undefined, mostramos un valor vacío
      })
      .join(" ")

    // Generar el label final con el código y descripción, y los atributos activos
    return `${item.codigo} - ${item.descripcion} - ${attributeValues} - ${item.codigoScanner}`
  }

  // Efecto para selección automática de item por código de scanner
  useEffect(() => {
    if (itemTresLetras) {
      if (searchText.length >= 3 && itemTresLetras.length > 0) {
        // Buscamos el ítem cuyo codigoScanner coincida exactamente con searchText
        const found = itemTresLetras.find((item) => item.codigoScanner === searchText)
        if (found) {
          const autoSelected = {
            label: generateItemLabel(found),
            descripcion: found.descripcion,
            codigo: found.codigo,
            id: found.id,
            codigoScanner: found.codigoScanner,
          }
          // Actualizamos el estado con el ítem seleccionado automáticamente
          setSelectedItem(autoSelected)
        }
      }
    }
  }, [searchText, itemTresLetras])

  // useEffect para ejecutar búsqueda automática cuando se selecciona un item
  useEffect(() => {
    if (selectedItem) {
      console.log("Item seleccionado, ejecutando búsqueda automática:", selectedItem)
      filtrarItemProveedor()
    }
  }, [selectedItem])

  // Función para filtrar items por cliente, item y ubicación - MANTENER LÓGICA DE MAIN
  const filtrarItemProveedor = async () => {
    setIsLoading(true)
    const idProveedor = selectedProveedor?.id || null
    const idItem = selectedItem?.id || null
    const idUbicacion = selectedUbicacion?.id || null

    // Nueva funcionalidad: si hay texto de búsqueda pero no hay item seleccionado,
    // realizar búsqueda múltiple
    const searchTextForMultiple = searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null

    console.log("=== FILTRAR ITEM PROVEEDOR ===")
    console.log("selectedItem:", selectedItem)
    console.log("searchText:", searchText)
    console.log("Ejecutando fetchItems con filtros:", {
      idProveedor,
      idItem,
      idUbicacion,
      searchTextForMultiple,
    })

    // Se ejecuta la consulta con todos los valores, permitiendo valores nulos
    await fetchItems(
      idProveedor,
      idItem,
      idUbicacion,
      soloUltimos,
      page,
      limit,
      searchTextForMultiple, // Pasar el texto de búsqueda múltiple
      incluirItemsSinPrecio, // Pasar el parámetro de items sin precio - MANTENER FUNCIONALIDAD DE MAIN
      filtrosAtributos, // NUEVO: Pasar filtros de atributos actuales
    )
    setIsLoading(false)
  }

  // Función para limpiar filtros
  const limpiarFiltros = () => {
    setSelectedProveedor(null)
    setSelectedItem(null)
    setSelectedUbicacion(null)
    setSearchText("")
    setSoloUltimos(true) // Resetear a true por defecto
    setIncluirItemsSinPrecio(false) // Mantener funcionalidad de main
    setFiltrosAtributos({}) // Limpiar filtros de atributos
    fetchItems(null, null, null, true, 1, limit, null, false, {}) // Mantener soloUltimos = true, incluirItemsSinPrecio = false, sin filtros
    setPage(1)
  }

  // Función para obtener items - MANTENER LÓGICA DE MAIN CON PARÁMETRO INCLUIR ITEMS SIN PRECIO
  const fetchItems = async (
    idProveedor,
    idItem,
    idUbicacion,
    soloUltimos,
    currentPage = page,
    pageLimit = limit,
    searchTextForMultiple = null, // Nuevo parámetro para búsqueda múltiple
    incluirItemsSinPrecio = false, // Mantener parámetro de main
    atributosFilters = {}, // NUEVO: Filtros dinámicos por atributos
  ) => {
    setIsLoading(true)
    setItemsProveedor([])
    try {
      const response = await getListaMontosByEntidad(
        idProveedor,
        idItem,
        idUbicacion,
        1, // Tipo entidad cliente
        currentPage,
        pageLimit,
        soloUltimos,
        searchTextForMultiple, // Pasar el texto de búsqueda múltiple
        incluirItemsSinPrecio, // Pasar el parámetro de items sin precio - MANTENER FUNCIONALIDAD DE MAIN
        atributosFilters, // NUEVO: Pasar filtros de atributos
      )

      const items = response.items
      console.log("=== FRONTEND: Datos recibidos del backend ===")
      console.log("Items recibidos:", items)
      console.log("Primer item:", items?.[0])

      if (items != null) {
        // Aplanar y ordenar
        const itemsTransformados = items.map((item, index) => ({
          id: item.id || `${item.idItem}-${item.idEntidad}-${item.idUbicacion}-${index}`, // Generar ID si no existe
          fecha: item.fecha,
          idItem: item.idItem,
          idEntidad: item.idEntidad,
          idUbicacion: item.idUbicacion,
          costo: item.costo,
          descripcionEntidad: item.descripcionEntidad,
          ubicacion: item.ubicacion?.descripcion || item.ubicacion || "Sin ubicación",
          descripcion: item.descripcion,
          codigo: item.codigo,
          codigoScanner: item.codigoScanner,
          // NUEVO: Incluir campos de atributos dinámicos
          itemDatoAtributo1: item.itemDatoAtributo1 || null,
          itemDatoAtributo2: item.itemDatoAtributo2 || null,
          itemDatoAtributo3: item.itemDatoAtributo3 || null,
          itemDatoAtributo4: item.itemDatoAtributo4 || null,
          itemDatoAtributo5: item.itemDatoAtributo5 || null,
          itemDatoAtributo6: item.itemDatoAtributo6 || null,
          itemDatoAtributo7: item.itemDatoAtributo7 || null,
          itemDatoAtributo8: item.itemDatoAtributo8 || null,
          itemDatoAtributo9: item.itemDatoAtributo9 || null,
          itemDatoAtributo10: item.itemDatoAtributo10 || null,
          leadTime: item.leadTime,
          eliminado: item.eliminado,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        }))

        // Ordenar por idItem
        itemsTransformados.sort((a, b) => a.idItem - b.idItem)

        console.log("=== FRONTEND: Datos transformados ===")
        console.log("Items transformados:", itemsTransformados)
        console.log("Primer item transformado:", itemsTransformados?.[0])

        setItemsProveedor(itemsTransformados)
      }
      setTotalPages(response.totalPages)
      setTotalCount(response.totalCount)
    } catch (error) {
      console.error("Error al obtener items:", error)
    } finally {
      setIsLoading(false)
    }
  }

  // Función para actualizar todos los precios respetando filtros actuales
  const onUpdateAllPrices = async (tipoAjuste, valorActualizar) => {
    if (!valorActualizar) {
      alert("Por favor ingrese un valor para actualizar los precios")
      return
    }

    setIsLoading(true)
    try {
      console.log("Actualizando precios filtrados con:", tipoAjuste, valorActualizar)

      // Determinar si estamos en modo búsqueda múltiple
      const searchTextForMultiple = searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null

      // Usar la nueva función que respeta filtros
      await updateFilteredPrices(
        tipoAjuste,
        valorActualizar,
        selectedProveedor?.id || null,
        selectedItem?.id || null,
        selectedUbicacion?.id || null,
        1, // Tipo entidad cliente
        soloUltimos,
        searchTextForMultiple,
        incluirItemsSinPrecio,
      )

      await filtrarItemProveedor()
      setUpdateSuccess(true)
      setTimeout(() => setUpdateSuccess(false), 3000)
    } catch (error) {
      console.error("Error al actualizar precios:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleAssociate = async (idCopiar, idPegar) => {
    // Llama a tu controller: copiar precios de sourceId a targetId
    await copiarPreciosEntreEntidades(idCopiar, idPegar)
    // Refresca la tabla si es necesario
    await filtrarItemProveedor()
  }

  // Funciones para el modal de edición de precio individual
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleOpenModal = (row) => {
    console.log("el row que llega es ", row)
    setPrecioLista(row)
    setOpenModal(true)
  }

  const onUpdate = async (idItem, idDeEntidad, idUbicacion, nuevoMonto, tipoAjuste) => {
    setIsLoading(true)
    try {
      await updateItemPrecioListaId(idItem, idDeEntidad ?? 1, idUbicacion ?? 1, nuevoMonto, tipoAjuste)
      setOpenModal(false)
      await filtrarItemProveedor()
      setUpdateSuccess(true)
      setTimeout(() => setUpdateSuccess(false), 3000)
    } catch (error) {
      console.error("Error al actualizar precio:", error)
    } finally {
      setIsLoading(false)
    }
  }

  // Función para abrir el modal de actualización múltiple
  const handleOpenModalActualizar = async () => {
    await cargarEntidadesSiNoExisten()
    setOpenModalActualizar(true)
  }

  // Función para actualizar precios de entidades seleccionadas
  const onUpdateMultiple = async (idEntidades, monto, tipoAjuste) => {
    if (!monto || isNaN(monto) || idEntidades.length === 0) {
      alert("Debe seleccionar al menos una entidad y un monto válido.")
      return
    }

    setIsLoading(true)
    try {
      // Determinar si estamos en modo búsqueda múltiple
      const searchTextForMultiple = searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null

      // Preparar filtros para enviar al backend
      const filtros = {
        idProveedor: selectedProveedor?.id || null,
        idItem: selectedItem?.id || null,
        idUbicacion: selectedUbicacion?.id || null,
        soloUltimos: soloUltimos,
        searchTextForMultiple: searchTextForMultiple,
        incluirItemsSinPrecio: incluirItemsSinPrecio,
        atributosFilters: filtrosAtributos,
        hayFiltrosActivos: hayFiltrosActivos, // Para que el backend sepa si aplicar filtros o no
      }

      await updatePreciosListaMultiple(idEntidades, Number.parseFloat(monto), tipoAjuste, filtros)
      await filtrarItemProveedor()
      setUpdateSuccess(true)
      setTimeout(() => setUpdateSuccess(false), 3000)
    } catch (error) {
      console.error("Error al actualizar precios múltiples:", error)
    } finally {
      setIsLoading(false)
    }
  }

  // FUNCIONALIDADES NUEVAS DE BRANCH_MAURI - Manejo de edición inline
  const handlePriceChange = (rowId, value) => {
    const str = String(value ?? "").replace(",", ".")
    setEditedPrices((prev) => ({ ...prev, [rowId]: str }))
  }

  const clearEdited = () => setEditedPrices({})

  useEffect(() => {
    if (!itemsProveedor) {
      setModifiedCount(0)
      return
    }
    const count = Object.entries(editedPrices).filter(([rowId, val]) => {
      const row = itemsProveedor.find((r) => String(r.id) === String(rowId))
      if (!row) return false
      const newNum = val === "" || val == null ? Number.NaN : Number.parseFloat(String(val).replace(",", "."))
      const oldNum = row.precio == null ? Number.NaN : Number(row.precio)
      return Number.isFinite(newNum) && (Number.isNaN(oldNum) || newNum !== oldNum)
    }).length
    setModifiedCount(count)
  }, [editedPrices, itemsProveedor])

  const applyEditedPrices = async () => {
    if (!itemsProveedor || itemsProveedor.length === 0) return

    const updates = Object.entries(editedPrices)
      .map(([rowId, val]) => {
        const row = itemsProveedor.find((r) => String(r.id) === String(rowId))
        if (!row) return null
        const newNum = val === "" || val == null ? Number.NaN : Number.parseFloat(String(val).replace(",", "."))
        const oldNum = row.precio == null ? Number.NaN : Number(row.precio)
        const changed = Number.isFinite(newNum) && (Number.isNaN(oldNum) || newNum !== oldNum)
        return changed
          ? { idItem: row.idItem, idEntidad: row.idEntidad ?? 1, idUbicacion: row.idUbicacion ?? 1, monto: newNum }
          : null
      })
      .filter(Boolean)

    if (updates.length === 0) {
      alert("No hay cambios para aplicar.")
      return
    }

    setSavingEdits(true)
    setIsLoading(true)
    try {
      // Ejecutar en serie para reducir pico de requests si son muchas filas
      for (const u of updates) {
        // Fallback a 1 si llegan undefined/null
        const idEntidad = u.idEntidad ?? 1
        const idUbicacion = u.idUbicacion ?? 1
        await updateItemPrecioListaId(u.idItem, idEntidad, idUbicacion, u.monto, "valor")
      }
      clearEdited()
      await filtrarItemProveedor()
      setUpdateSuccess(true)
      setTimeout(() => setUpdateSuccess(false), 3000)
    } catch (e) {
      console.error("Error al aplicar cambios de precios:", e)
      alert("Ocurrió un error al aplicar los cambios.")
    } finally {
      setSavingEdits(false)
      setIsLoading(false)
    }
  }

  // FUNCIONALIDADES NUEVAS DE BRANCH_MAURI - Enfocar y seleccionar el input solo cuando se presiona Enter
  useEffect(() => {
    if (!editMode || editingRowId == null || !shouldFocusOnEnter) return
    const ref = priceInputRefs.current[editingRowId]
    if (ref && typeof ref.focus === "function") {
      // Esperar al render del input
      setTimeout(() => {
        try {
          ref.focus()
          if (editModeInternal) {
            // En modo interno: mover cursor al final sin seleccionar
            const len = String(ref.value ?? "").length
            if (ref.setSelectionRange) ref.setSelectionRange(len, len)
          } else if (selectAllOnEdit) {
            // En modo normal: seleccionar todo el contenido
            if (ref.select) ref.select()
            else if (ref.setSelectionRange) ref.setSelectionRange(0, String(ref.value ?? "").length)
          } else {
            // Mover cursor al final
            const len = String(ref.value ?? "").length
            if (ref.setSelectionRange) ref.setSelectionRange(len, len)
          }
          // Resetear el flag después de enfocar
          setShouldFocusOnEnter(false)
        } catch (_) {}
      }, 0)
    }
  }, [editingRowId, editMode, selectAllOnEdit, editModeInternal, shouldFocusOnEnter])

  // Limpiar ediciones cuando cambian los datos de la tabla
  useEffect(() => {
    clearEdited()
  }, [itemsProveedor])

  // Inicializar la primera fila para edición cuando se cargan datos y está en modo edición
  useEffect(() => {
    if (editMode && itemsProveedor.length > 0 && !editingRowId) {
      setEditingRowId(itemsProveedor[0].id)
      setSelectAllOnEdit(true)
      setEditModeInternal(false)
    }
  }, [editMode, itemsProveedor, editingRowId])

  // === FUNCIONES HELPER PARA FILTROS DINÁMICOS POR ATRIBUTOS ===

  /**
   * Mapea los atributos activos a sus campos correspondientes
   */
  const mapearAtributosACampos = () => {
    return itemAtributoNoEliminados
      .filter((attr) => !attr.eliminado)
      .map((attr, index) => ({
        id: attr.id,
        descripcion: attr.descripcion,
        campo: `itemDatoAtributo${index + 1}`,
        index: index + 1,
      }))
  }

  /**
   * Handler para cambios en filtros de atributos
   */
  const handleAtributoFilterChange = (campo, valor) => {
    setFiltrosAtributos((prev) => ({
      ...prev,
      [campo]: valor,
    }))
  }

  // ELIMINADO: esta función estaba duplicada y era la causa del error lint/suspicious/noRedeclare
  // const contarFiltrosActivos = () => {
  //   let count = 0
  //   if (!soloUltimos) count++ // Si está desactivado, cuenta como filtro
  //   if (incluirItemsSinPrecio) count++
  //   if (cantidadFiltrosAtributosActivos > 0) count += cantidadFiltrosAtributosActivos
  //   if (editMode) count++
  //   return count
  // }

  /**
   * Handler para teclas en inputs de atributos
   * Solo permite Escape para limpiar el campo
   */
  const handleAtributoKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleAplicarFiltrosAtributos()
    }
  }

  /**
   * Limpiar filtros de atributos
   */
  const handleLimpiarFiltrosAtributos = () => {
    setFiltrosAtributos({})
    fetchItems(
      selectedProveedor?.id || null,
      selectedItem?.id || null,
      selectedUbicacion?.id || null,
      soloUltimos,
      page,
      limit,
      searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null,
      incluirItemsSinPrecio,
      {}, // Sin filtros
    )
  }

  /**
   * Contador de filtros activos
   */
  const cantidadFiltrosAtributosActivos = Object.values(filtrosAtributos).filter(
    (valor) => valor && valor.trim() !== "",
  ).length

  /**
   * Toggle filtros avanzados
   */
  // const mostrarFiltros = () => setMasFiltrosActive(!masFiltrosActive); // Reemplazado por Collapse en Drawer

  const handleToggleSoloUltimos = () => {
    const newValue = !soloUltimos
    setSoloUltimos(newValue)
    if (newValue) {
      setIncluirItemsSinPrecio(false)
    }
    // Ejecutar búsqueda inmediatamente
    fetchItems(
      selectedProveedor?.id || null,
      selectedItem?.id || null,
      selectedUbicacion?.id || null,
      newValue,
      page,
      limit,
      searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null,
      newValue ? false : incluirItemsSinPrecio,
      filtrosAtributos,
    )
  }

  const handleToggleItemsSinPrecio = () => {
    const newValue = !incluirItemsSinPrecio
    setIncluirItemsSinPrecio(newValue)
    if (newValue) {
      setSoloUltimos(false)
    }
    // Ejecutar búsqueda inmediatamente
    fetchItems(
      selectedProveedor?.id || null,
      selectedItem?.id || null,
      selectedUbicacion?.id || null,
      newValue ? false : soloUltimos,
      page,
      limit,
      searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null,
      newValue,
      filtrosAtributos,
    )
  }

  const handleToggleEditMode = () => {
    const newValue = !editMode
    setEditMode(newValue)
    if (!newValue) clearEdited()
  }

  const handleAplicarFiltrosAtributos = () => {
    fetchItems(
      selectedProveedor?.id || null,
      selectedItem?.id || null,
      selectedUbicacion?.id || null,
      soloUltimos,
      page,
      limit,
      searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null,
      incluirItemsSinPrecio,
      filtrosAtributos,
    )
  }

  // === COLUMNAS DINÁMICAS DE ATRIBUTOS ===
  const dynamicColumns = itemAtributoNoEliminados
    .filter((attr) => !attr.eliminado)
    .map((attr, index) => ({
      field: `itemDatoAtributo${index + 1}`,
      headerName: attr.descripcion,
      width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <Typography variant="body2">{params.value || "-"}</Typography>,
    }))

  // Definición de columnas para el DataGrid
  const columns = [
    {
      field: "fecha",
      headerName: "Fecha",
      width: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "codigo",
      headerName: "Código",
      width: 120,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          variant="outlined"
          sx={{
            fontWeight: 500,
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
          }}
        />
      ),
    },
    {
      field: "codigoScanner",
      headerName: "Código de Barras",
      width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      width: 220,
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    // === COLUMNAS DINÁMICAS DE ATRIBUTOS INSERTADAS AQUÍ ===
    ...dynamicColumns,
    {
      field: "ubicacion",
      headerName: "Ubicación",
      headerAlign: "center",
      width: 180,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarehouseIcon fontSize="small" color="action" />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "descripcionEntidad",
      headerName: "Cliente",
      headerAlign: "center",
      width: 200,
      flex: 1.5,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonIcon fontSize="small" color="action" />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "costo",
      headerName: "Precio",
      width: 130,
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => {
        const rowId = params.row.id
        const original = params.value
        const edited = editedPrices[rowId]
        const editedNum =
          edited === undefined || edited === "" ? null : Number.parseFloat(String(edited).replace(",", "."))
        const isChanged =
          edited !== undefined && edited !== "" && Number.isFinite(editedNum) && editedNum !== Number(original)

        // FUNCIONALIDAD NUEVA DE BRANCH_MAURI - En modo edición: todos los precios se muestran como TextField con color de texto dinámico
        if (editMode) {
          return (
            <TextField
              size="small"
              type="number"
              defaultValue={edited !== undefined ? edited : (original ?? "")}
              onBlur={(e) => handlePriceChange(rowId, e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                  const value = e.currentTarget.value
                  handlePriceChange(rowId, value)
                  const idx = itemsProveedor.findIndex((r) => String(r.id) === String(rowId))
                  const next = idx >= 0 && idx + 1 < itemsProveedor.length ? itemsProveedor[idx + 1] : null
                  if (next) {
                    setEditingRowId(next.id)
                    setSelectAllOnEdit(true) // modo reemplazo completo
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(true) // Enfocar con Enter
                  }
                }
                // Manejar flechas para navegación
                if (e.key === "ArrowDown") {
                  e.preventDefault()
                  const value = e.currentTarget.value
                  handlePriceChange(rowId, value)
                  const idx = itemsProveedor.findIndex((r) => String(r.id) === String(rowId))
                  const next = idx >= 0 && idx + 1 < itemsProveedor.length ? itemsProveedor[idx + 1] : null
                  if (next) {
                    setEditingRowId(next.id)
                    setSelectAllOnEdit(true)
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(false) // No enfocar con flechas
                  }
                }
                if (e.key === "ArrowUp") {
                  e.preventDefault()
                  const value = e.currentTarget.value
                  handlePriceChange(rowId, value)
                  const idx = itemsProveedor.findIndex((r) => String(r.id) === String(rowId))
                  const prev = idx > 0 ? itemsProveedor[idx - 1] : null
                  if (prev) {
                    setEditingRowId(prev.id)
                    setSelectAllOnEdit(true)
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(false) // No enfocar con flechas
                  }
                }
              }}
              onFocus={(e) => {
                try {
                  if (selectAllOnEdit && !editModeInternal && e.target && e.target.select) {
                    e.target.select()
                  }
                } catch (_) {}
              }}
              onMouseDown={(e) => {
                // 1 click: seleccionar todo; 2 clicks: caret/edición parcial
                if (e && typeof e.detail === "number") {
                  setSelectAllOnEdit(e.detail !== 2)
                }
              }}
              inputProps={{
                step: "0.01",
                style: {
                  color: isChanged ? "rgb(244, 177, 14)" : theme.palette.secondary.main,
                  fontWeight: 700,
                },
              }}
              inputRef={(el) => {
                priceInputRefs.current[rowId] = el
              }}
              sx={{ width: "100%" }}
            />
          )
        }

        // Modo lectura normal
        return (
          <Typography
            variant="body2"
            sx={{
              color: params.value === null ? theme.palette.text.secondary : theme.palette.secondary.main,
              fontWeight: "bold",
              backgroundColor:
                params.value === null
                  ? alpha(theme.palette.text.secondary, 0.1)
                  : alpha(theme.palette.secondary.main, 0.1),
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.value === null ? "-" : `$${params.value?.toLocaleString("es-AR") || "0.00"}`}
          </Typography>
        )
      },
    },
    {
      field: "action",
      headerName: "Acciones",
      width: 100,
      flex: 0.3,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={() => handleOpenModal(params.row)}
          sx={{
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
          }}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      ),
    },
  ]

  // Helper para contar filtros activos totales
  /**
   * Contador de filtros activos totales
   */
  const contarFiltrosActivos = () => {
    let count = 0
    if (selectedProveedor) count++
    if (selectedItem) count++
    if (selectedUbicacion) count++
    if (searchText && searchText.trim() !== "") count++
    if (!soloUltimos) count++ // Si está desactivado, cuenta como filtro
    if (incluirItemsSinPrecio) count++
    count += cantidadFiltrosAtributosActivos
    return count
  }

  const totalFiltrosActivos = contarFiltrosActivos()

  // Definir handleItemChange: se encontraba no declarada.
  const handleItemChange = (event, newValue) => {
    if (typeof newValue === "string") {
      setSearchText(newValue)
      setSelectedItem(null)
    } else {
      setSelectedItem(newValue)
      if (newValue) {
        setSearchText(newValue.label) // Actualiza el campo de búsqueda con la selección
      }
    }
  }

  // </CHANGE> Fin del panel lateral de filtros

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Cambiado a column para que el header y footer se queden fijos
          height: "100vh",
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            borderRadius: "8px 8px 0 0",
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "stretch", md: "center" },
              gap: 2,
            }}
          >
            {/* Búsqueda de Ítem */}
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                fullWidth
                size="small"
                disablePortal
                freeSolo
                options={(itemTresLetras || []).map((it) => ({
                  label: generateItemLabel(it),
                  descripcion: it.descripcion,
                  codigo: it.codigo,
                  id: it.id,
                  codigoScanner: it.codigoScanner,
                }))}
                value={selectedItem}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setSearchText(newValue)
                    setSelectedItem(null)
                  } else {
                    handleItemChange(event, newValue)
                    setSelectedItem(newValue)
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  setSearchText(newInputValue)
                  if (!newInputValue || newInputValue.trim() === "") {
                    setSelectedItem(null)
                  }
                }}
                inputValue={searchText}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Buscar ítem"
                    placeholder="Código, descripción o barras"
                    onKeyPress={(event) => {
                      if (event.key === "Enter" && searchText && searchText.trim() !== "" && !selectedItem) {
                        event.preventDefault()
                        filtrarItemProveedor()
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <SearchIcon color="action" />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                      endAdornment: (selectedItem || (searchText && searchText.trim() !== "")) && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedItem(null)
                              setSearchText("")
                            }}
                            sx={{ color: theme.palette.text.secondary }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            {/* Cliente */}
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                fullWidth
                size="small"
                options={proveedores}
                getOptionLabel={(option) => `${option.descripcion + " " + option.apellido}`}
                value={selectedProveedor}
                onChange={(event, newValue) => setSelectedProveedor(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <PersonIcon color="action" />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            {/* Ubicación */}
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                fullWidth
                size="small"
                disablePortal
                options={ubicaciones.map((it) => ({
                  id: it.id,
                  label: it.descripcion,
                }))}
                value={selectedUbicacion}
                onChange={(event, newValue) => {
                  setSelectedUbicacion(newValue)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ubicación"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <WarehouseIcon color="action" />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            {/* Botones de acción */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="contained"
                onClick={filtrarItemProveedor}
                startIcon={<SearchIcon />}
                disabled={isLoading}
              >
                Buscar
              </Button>
              <Button variant="outlined" onClick={limpiarFiltros} startIcon={<FilterAltOffIcon />} disabled={isLoading}>
                Limpiar
              </Button>
              <Tooltip title={filterDrawerOpen ? "Ocultar filtros avanzados" : "Mostrar más filtros"}>
                <Badge badgeContent={contarFiltrosActivos()} color="primary">
                  <IconButton
                    onClick={() => setFilterDrawerOpen(!filterDrawerOpen)}
                    size="medium"
                    sx={{
                      color: theme.palette.primary.main,
                      border: `1px solid ${alpha(theme.palette.primary.main, filterDrawerOpen ? 0.5 : 0.3)}`,
                      bgcolor: filterDrawerOpen ? alpha(theme.palette.primary.main, 0.1) : "transparent",
                      transition: "background-color 0.2s ease",
                      "&:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.15),
                      },
                    }}
                  >
                    <TuneIcon />
                  </IconButton>
                </Badge>
              </Tooltip>
            </Box>
          </Box>

          {(mostrarFiltroAtributos || mostrarActualizacionPrecios) && (
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                pt: 2,
              }}
            >
              {/* Filtros por Atributos */}
              {mostrarFiltroAtributos && itemAtributoNoEliminados && itemAtributoNoEliminados.length > 0 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                      Filtros por Atributos
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroAtributos(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                      gap: 2,
                    }}
                  >
                    {mapearAtributosACampos().map((atributo) => (
                      <TextField
                        key={atributo.campo}
                        label={atributo.descripcion}
                        size="small"
                        value={filtrosAtributos[atributo.campo] || ""}
                        onChange={(e) => handleAtributoFilterChange(atributo.campo, e.target.value)}
                        onKeyDown={handleAtributoKeyDown}
                        placeholder={`Buscar...`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: filtrosAtributos[atributo.campo] && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => handleAtributoFilterChange(atributo.campo, "")}
                                edge="end"
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: filtrosAtributos[atributo.campo]
                              ? alpha(theme.palette.primary.main, 0.05)
                              : "white",
                          },
                        }}
                      />
                    ))}
                  </Box>

                  {cantidadFiltrosAtributosActivos > 0 && (
                    <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "flex-end" }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleAplicarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Aplicar Filtros
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleLimpiarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  )}
                </Paper>
              )}

              {/* Actualización de Precios */}
              {mostrarActualizacionPrecios && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.secondary.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.secondary.main }}>
                      Actualización de Precios
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarActualizacionPrecios(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 600 }}>
                    {/* Tipo de ajuste */}
                    <FormControl size="small" fullWidth>
                      <InputLabel>Tipo de Ajuste</InputLabel>
                      <Select
                        value={tipoAjuste}
                        onChange={(e) => setTipoAjuste(e.target.value)}
                        label="Tipo de Ajuste"
                        startAdornment={
                          <InputAdornment position="start">
                            {tipoAjuste === "porcentaje" ? (
                              <PercentIcon color="action" fontSize="small" />
                            ) : (
                              <AttachMoneyIcon color="action" fontSize="small" />
                            )}
                          </InputAdornment>
                        }
                      >
                        <MenuItem value="porcentaje">Porcentaje (%)</MenuItem>
                        <MenuItem value="valor">Valor Fijo ($)</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Valor a actualizar */}
                    <TextField
                      size="small"
                      fullWidth
                      label={tipoAjuste === "porcentaje" ? "Porcentaje" : "Valor"}
                      type="number"
                      value={valorActualizar}
                      onChange={(e) => setValorActualizar(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">{tipoAjuste === "porcentaje" ? "%" : "$"}</InputAdornment>
                        ),
                      }}
                    />

                    {/* Botón actualizar todos */}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => onUpdateAllPrices(tipoAjuste, Number.parseFloat(valorActualizar))}
                      startIcon={<PriceChangeIcon />}
                      disabled={isLoading || !valorActualizar}
                      sx={{ textTransform: "none" }}
                    >
                      Actualizar Todos los Precios
                    </Button>
                  </Box>
                </Paper>
              )}
            </Box>
          )}
        </Box>

        {/* Sección independiente para modo edición */}
        {editMode && (
          <Box sx={{ p: 2, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
            <Paper sx={{ p: 2, backgroundColor: alpha(theme.palette.primary.main, 0.05) }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="h6" sx={{ color: theme.palette.primary.main, fontWeight: 600 }}>
                  Modo Edición Activo
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                  {modifiedCount} precio{modifiedCount !== 1 ? 's' : ''} modificado{modifiedCount !== 1 ? 's' : ''}
                </Typography>
                <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={applyEditedPrices}
                    disabled={savingEdits || modifiedCount === 0}
                    sx={{ textTransform: "none" }}
                  >
                    Guardar cambios ({modifiedCount})
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={clearEdited}
                    startIcon={<ClearIcon />}
                    sx={{ textTransform: "none" }}
                  >
                    Cancelar
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Box>
        )}

        <Drawer
          anchor="right"
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          variant="persistent"
          sx={{
            "& .MuiDrawer-paper": {
              width: 80,
              top: 0,
              height: "100vh",
              backgroundColor: alpha(theme.palette.background.paper, 0.98),
              borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
              zIndex: 1200,
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                pb: 1,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              <IconButton size="small" onClick={() => setFilterDrawerOpen(false)}>
                <ChevronRightIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
              {/* Filtros simples que ejecutan inmediatamente */}
              <Tooltip title="Solo último precio" placement="left">
                <IconButton
                  onClick={handleToggleSoloUltimos}
                  sx={{
                    color: soloUltimos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: soloUltimos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <CheckBoxIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Items sin precio" placement="left">
                <IconButton
                  onClick={handleToggleItemsSinPrecio}
                  sx={{
                    color: incluirItemsSinPrecio ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: incluirItemsSinPrecio ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <MoneyOffIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Modo edición de precios" placement="left">
                <IconButton
                  onClick={handleToggleEditMode}
                  sx={{
                    color: editMode ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: editMode ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>

              <Divider sx={{ my: 1 }} />

              {/* Filtros avanzados */}
              <Tooltip title="Filtrar por atributos" placement="left">
                <IconButton
                  onClick={() => setMostrarFiltroAtributos(!mostrarFiltroAtributos)}
                  sx={{
                    color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <Badge badgeContent={cantidadFiltrosAtributosActivos} color="primary">
                    <FilterAltIcon />
                  </Badge>
                </IconButton>
              </Tooltip>

              <Tooltip title="Actualización de precios" placement="left">
                <IconButton
                  onClick={() => setMostrarActualizacionPrecios(!mostrarActualizacionPrecios)}
                  sx={{
                    color: mostrarActualizacionPrecios ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: mostrarActualizacionPrecios ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <PriceChangeIcon />
                </IconButton>
              </Tooltip>

              <Divider sx={{ my: 1 }} />

              {/* Botones que abren modales */}
              <Tooltip title="Actualizar por entidades" placement="left">
                <IconButton
                  onClick={handleOpenModalActualizar}
                  sx={{
                    color: "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <PersonIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Asociar precios entre entidades" placement="left">
                <IconButton
                  onClick={async () => {
                    await cargarEntidadesSiNoExisten()
                    setOpenAsociar(true)
                  }}
                  sx={{
                    color: "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <SwapHorizIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Drawer>

        {/* </CHANGE> Fin del área principal */}

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            // transition: "margin-left 0.3s ease", // Movido a Drawer
            // marginLeft: filterDrawerOpen ? "360px" : "0px", // Movido a Drawer
          }}
        >
          

          {/*Tabla */}
          <Box sx={{ flex: 1, overflow: "hidden", p: 2 }}>
            <Paper
              sx={{
                height: "100%",
                width: "100%",
                boxShadow: "none",
                border: "1px solid rgba(0,0,0,0.08)",
                borderTop: "none",
              }}
            >
              <DataGrid
                key={isNavbarCollapsed ? "collapsed" : "expanded"}
                className="tablaVentasDataGrid"
                rows={itemsProveedor}
                columns={columns}
                getRowId={(row) => row.id}
                rowCount={totalCount}
                loading={isLoading}
                paginationMode="server"
                disableColumnMenu
                disableSelectionOnClick
                getRowHeight={() => 35}
                headerHeight={35}
                autoHeight={false}
                // FUNCIONALIDAD NUEVA DE BRANCH_MAURI - Eventos para navegación en modo edición
                onCellClick={(params) => {
                  if (editMode && params.field === "costo") {
                    setEditingRowId(params.row.id)
                    setSelectAllOnEdit(true) // seleccionar todo al entrar
                    setEditModeInternal(false) // modo reemplazo completo
                    setShouldFocusOnEnter(false) // No enfocar con click
                  }
                }}
                onCellDoubleClick={(params) => {
                  if (editMode && params.field === "costo") {
                    setEditingRowId(params.row.id)
                    setSelectAllOnEdit(false) // no seleccionar todo (caret)
                    setEditModeInternal(true) // modo edición interna
                    setShouldFocusOnEnter(false) // No enfocar con doble click
                  }
                }}
                onCellKeyDown={(params, event) => {
                  if (!editMode) return
                  if (params.field === "costo" && event.key === "Enter") {
                    event.preventDefault()
                    setEditingRowId(params.row.id)
                    setSelectAllOnEdit(true) // modo reemplazo completo
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(true) // Enfocar con Enter
                  }
                  // Manejar flechas arriba/abajo para navegación
                  if (params.field === "costo" && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
                    event.preventDefault()
                    setEditingRowId(params.row.id)
                    setSelectAllOnEdit(true)
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(false) // No enfocar con flechas
                  }
                }}
                onRowKeyDown={(params, event) => {
                  if (!editMode) return

                  // Navegación con flechas cuando no hay celda en edición
                  if (event.key === "ArrowDown") {
                    event.preventDefault()
                    const idx = itemsProveedor.findIndex((r) => String(r.id) === String(params.row.id))
                    const next = idx >= 0 && idx + 1 < itemsProveedor.length ? itemsProveedor[idx + 1] : null
                    if (next) {
                      setEditingRowId(next.id)
                      setSelectAllOnEdit(true)
                      setEditModeInternal(false)
                      setShouldFocusOnEnter(false) // No enfocar con flechas
                    }
                  }
                  if (event.key === "ArrowUp") {
                    event.preventDefault()
                    const idx = itemsProveedor.findIndex((r) => String(r.id) === String(params.row.id))
                    const prev = idx > 0 ? itemsProveedor[idx - 1] : null
                    if (prev) {
                      setEditingRowId(prev.id)
                      setSelectAllOnEdit(true)
                      setEditModeInternal(false)
                      setShouldFocusOnEnter(false) // No enfocar con flechas
                    }
                  }
                  if (event.key === "Enter") {
                    event.preventDefault()
                    setEditingRowId(params.row.id)
                    setSelectAllOnEdit(true)
                    setEditModeInternal(false)
                    setShouldFocusOnEnter(true) // Enfocar con Enter
                  }
                }}
                localeText={{
                  noRowsLabel: selectedProveedor
                    ? "No se encontraron registros para los filtros seleccionados"
                    : "Seleccione un cliente para ver sus precios",
                  noResultsOverlayLabel: "No se encontraron resultados",
                  loadingLabel: "Cargando...",
                }}
                sx={{
                  width: "100%",
                  border: 0,
                  "& .MuiDataGrid-footerContainer": {
                    display: "none !important",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    //MANEJA CSS HEADER
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    borderBottom: "2px solid #333",
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    //MANEJA CSS HEADER
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    //MANEJA CSS HEADER
                    color: "white !important",
                    lineHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                    color: "white !important",
                  },
                  "& .MuiDataGrid-menuIconButton": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiInputBase-root": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiTablePagination-root": {
                    color: "black !important",
                  },
                  "& .MuiSelect-icon": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "& .MuiDataGrid-row": {
                    "&:nth-of-type(even)": {
                      backgroundColor: "#F7F7F7",
                    },
                    "&:hover": {
                      backgroundColor: "#E3EAFD",
                      transition: "background 0.3s ease",
                    },
                  },
                  "& .row-devolucion": {
                    backgroundColor: alpha("#9e9e9e !important", 0.05),
                    "&:hover": {
                      backgroundColor: alpha("#9e9e9e !important", 0.1),
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    lineHeight: "none !important",
                    height: "10px !imporant",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #ddd",
                    zIndex: 10,
                  },
                  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                    width: "2px",
                  },
                  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "10px",
                  },
                }}
                components={{
                  Pagination: () => null,
                }}
              />
            </Paper>
          </Box>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            p: 1.5,
            backgroundColor: "#f5f5f5",
            borderRadius: "0 0 8px 8px",
            borderTop: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            montoTotalTransacciones={null}
            vieneDe="itemProveedor"
            onPageChange={(newPage) => {
              setPage(newPage)
              // Determinar si estamos en modo búsqueda múltiple
              const searchTextForMultiple =
                searchText && searchText.trim() !== "" && !selectedItem ? searchText.trim() : null
              fetchItems(
                selectedProveedor?.id,
                selectedItem?.id,
                selectedUbicacion?.id,
                soloUltimos,
                newPage,
                limit,
                searchTextForMultiple,
                incluirItemsSinPrecio, // Mantener parámetro de main
                filtrosAtributos, // NUEVO: Pasar filtros de atributos
              )
            }}
          />
        </Box>

        {/* </CHANGE> Fin del área principal */}

        {/* Alerta de éxito */}
        {updateSuccess && (
          <Fade in={updateSuccess}>
            <Alert
              severity="success"
              variant="filled"
              sx={{
                // Posición fija para la alerta
                position: "fixed",
                top: 16,
                right: 16,
                zIndex: 10000,
                boxShadow: 3,
              }}
            >
              Precios actualizados correctamente
            </Alert>
          </Fade>
        )}

        {/* Modales */}
        <ModalEditarPrecioId
          open={openModal}
          handleClose={handleCloseModal}
          precioLista={precioLista}
          onUpdate={onUpdate}
        />

        <ModalActualizarPrecioEntidades
          open={openModalActualizar}
          handleClose={() => setOpenModalActualizar(false)}
          entidades={entidadesFiltradas}
          onUpdate={onUpdateMultiple}
        />

        <ModalAsociarItemPorCliente
          open={openAsociar}
          handleClose={() => setOpenAsociar(false)}
          entidades={entidadesFiltradas}
          onAssociate={handleAssociate}
        />
      </Box>
    </ThemeProvider>
  )
}
